import React, { useEffect, useRef, useState, useCallback } from 'react';
import styles from './Carousel.module.css';
import CategoriesCard from './CategoriesCard';
import categories from "./Categories";

const TOTAL = categories.length;
const mod = (n, m) => ((n % m) + m) % m;

const Carousel = () => {
    const [index, setIndex] = useState(2);
    const intervalRef = useRef(null);

    const handleArrows = useCallback((delta) => {
        setIndex((prev) => mod(prev + delta, TOTAL));
    }, []);

    useEffect(() => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setIndex((prev) => mod(prev + 1, TOTAL));
        }, 5000);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [index]);

    return (
        <div className={styles.layout}>
            {/* <h1 className={styles.title}>Dealygo: <span className={styles.highlight}>À chacun son deal.</span></h1> */}
            <div className={styles.carousel}>
                <CategoriesCard categorie={categories[mod(index - 1, TOTAL)]} />
                <CategoriesCard categorie={categories[index]} handleArrows={handleArrows} />
                <CategoriesCard categorie={categories[mod(index + 1, TOTAL)]} />
            </div>
            <div className={styles.radioSection}>
                {categories.map((_, i) => (
                <input
                    key={i}
                    checked={index === i}
                    onChange={() => setIndex(i)}
                    className={styles.radio}
                    type="radio"
                />
                ))}
            </div>
        </div>
    );
};

export default Carousel;
